// This validator takes two control names, and checks a required dependency, meaning that the
// dependantControlName FormControl cannot have a a value unless the controlName FormControl also has a value

import { AbstractControl, ValidatorFn } from "@angular/forms"

export function DependantRequiredValidator(controlName: string, dependantControlName: string): ValidatorFn {
  return (group: AbstractControl): { [key: string]: any } | null => {
    let control = group.get(controlName);
    let dependantControl = group.get(dependantControlName);

    return (control && dependantControl && !control.value && dependantControl.value) ? { "dependantRequired": true } : null;
  }
}
